import dayjs from 'dayjs';
import { Select, MenuItem } from '@mui/material';

const renderSelectEditCell = (params) => {
  const { id, value, field, api } = params;

  const handleChange = async (event) => {
    const newValue = event.target.value;

    await api.setEditCellValue({
      id,
      field,
      value: newValue,
    });

    // 🔥 instant commit (no click outside needed)
    api.stopCellEditMode({ id, field });
  };

  return (
    <Select fullWidth value={value ?? 0} onChange={handleChange} size="small">
      <MenuItem value={1}>Yes</MenuItem>
      <MenuItem value={0}>No</MenuItem>
    </Select>
  );
};

export const taskConfigColumns = [
  { field: 'serialNumber', headerName: 'SlNo', maxWidth: 60 },

  {
    field: 'dept_name',
    headerName: 'Department',
    flex: 1.5,
    minWidth: 180,
  },

  {
    field: 'pm_approval_needed',
    headerName: 'PM Approval',
    flex: 1,
    minWidth: 160,
    editable: true,
    renderCell: (params) => (params.value ? 'Yes' : 'No'),
    renderEditCell: renderSelectEditCell,
  },

  // {
  //   field: 'delta_approval_needed',
  //   headerName: 'Delta Approval',
  //   flex: 1,
  //   minWidth: 160,
  //   editable: true,
  //   renderCell: (params) => (params.value ? 'Yes' : 'No'),
  //   renderEditCell: renderSelectEditCell,
  // },

  {
    field: 'type',
    headerName: 'Type',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      const map = {
        1: 'Incoming',
        2: 'Outgoing',
      };
      return map[params.value] || 'Unknown';
    },
  },

  {
    field: 'created_on',
    headerName: 'Created On',
    flex: 1.5,
    minWidth: 180,
    valueGetter: (params) => (params.value ? dayjs(params.value).format('DD MMM YYYY, hh:mm A') : ''),
  },
];
